// @flow
export function isNode(): boolean {
    return typeof window === 'undefined' || typeof window.document === 'undefined';
}
